<ng-template #restoPublishModal let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
  </div>
  <div class="modal-body">
    <h5 class="modal-info-text light info-text">
      Thank you for registering your business. We maintain strict quality standards and will review your submission shortly. Your listing will be live as soon as it's approved.
    </h5>
    <div class="btn-grps">
      <app-button [btnCss]="'btn btn-primary w-100 btn-lg btn-md'" [btnText]="'Close'" [btnTitle]="'Close'" (onBtnClick)="modal.close('Close click')"></app-button>
    </div>
  </div>
</ng-template>
